/** 公司/账号保存后通知同页及同源其他标签页；只广播失效信号，不在浏览器存储业务资料。 */
export const SUB_DIRECTORY_CHANGED = "subcontractor-directory-changed";
export const SUB_DIRECTORY_STORAGE = "ali_subcontractor_directory_revision";

/** 集中识别成功写入，覆盖公司库、财务入口、账号开通/关联及合同绑定，避免各页面漏发。 */
export const changesSubcontractorDirectory = (config = {}) => {
  if (!["post", "patch", "put", "delete"].includes(String(config.method || "get").toLowerCase())) return false;
  const path = String(config.url || "").split("?")[0].replace(/^https?:\/\/[^/]+/, "").replace(/^\/api(?=\/)/, "");
  return /^\/subcontractor-companies(?:\/|$)/.test(path) || /^\/users(?:\/|$)/.test(path) || /^\/subcontracts\/[^/]+\/assign-account$/.test(path);
};

export function notifySubcontractorDirectoryChanged() {
  window.dispatchEvent(new Event(SUB_DIRECTORY_CHANGED));
  try { localStorage.setItem(SUB_DIRECTORY_STORAGE, `${Date.now()}-${Math.random()}`); } catch { /* 禁止存储时仍有同页通知及后台轮询。 */ }
}
